//#region Libraries
import { Link } from 'react-router-dom';
import styled from "styled-components";
//#endregion

export const Container = styled(Link)`
    text-decoration: none;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 0;
    gap: 10px;
    border-radius: 12px;
    width: 260px;
    min-height: 90px;
    background-color: var(--light-1);
    box-shadow: 0 12px 24px -24px rgba(22, 29, 31, 0.45);
    & svg, & path {
        fill: var(--purple-2);
    }
    &, & *:not(svg) {
        transition: 0.35s;
    }
    &:hover {
        background-color: var(--purple-2);
        & * {
            color: var(--light-1) !important;
        }
        & svg, & path {
            fill: var(--light-1);
        }
    }
    &.secondary {
        border: 1px solid var(--purple-2);
        justify-content: center;
        align-items: stretch;
        padding: clamp(16px, 2vw, 18px) clamp(14px, 2vw, 16px);
        width: 100%;
        max-width: 100%;
        min-height: 120px;
        height: auto;
        box-shadow: 0 10px 24px -26px rgba(95, 37, 159, 0.45);
    }
    @media (max-width: 560px) {
        width: 100%;
        min-height: 112px;
    }
`;
export const Title = styled.div` 
    font-style: normal;
    font-weight: 900;
    font-size: 14px;
    line-height: 20px;
    width: 180px;
    color: var(--purple-6);
    margin: 0;
    word-break: break-word;
    &.secondary {
        width: 100%;
        min-width: 0;
        text-align: left;
        white-space: normal;
        overflow: visible;
        text-overflow: unset;
        line-height: 1.45;
    }
`;

 
